import { getId } from 'utils/getId';

export const mapToIds = (hydraIds?: string[]): string[] | undefined => {
  return hydraIds?.map((id) => getId(id));
};
